var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import ModelTraits from "../ModelTraits";
import primitiveTrait from "../Decorators/primitiveTrait";
let ScaleByDistanceTraits = (_dec = primitiveTrait({
  name: "Near",
  description: "The lower bound of the camera distance range.",
  type: "number"
}), _dec2 = primitiveTrait({
  name: "Near Scale Value",
  description: "The scale value to use when the camera is at the `Near` distance (or " + "closer). A value greater than 1.0 enlarges the image while a scale " + "less than 1.0 shrinks it.",
  type: "number"
}), _dec3 = primitiveTrait({
  name: "Far",
  description: "The upper bound of the camera distance range.",
  type: "number"
}), _dec4 = primitiveTrait({
  name: "Far Scale Value",
  description: "The scale value to use when the camera is at the `Far` distance (or " + "farther). A value greater than 1.0 enlarges the image while a scale " + "less than 1.0 shrinks it.",
  type: "number"
}), _class = class ScaleByDistanceTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "near", _descriptor, this);
    _initializerDefineProperty(this, "nearValue", _descriptor2, this);
    _initializerDefineProperty(this, "far", _descriptor3, this);
    _initializerDefineProperty(this, "farValue", _descriptor4, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "near", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0.0;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "nearValue", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 1.0;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "far", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 1.0;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "farValue", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 1.0;
  }
}), _class);
export { ScaleByDistanceTraits as default };